module.exports = __webpack_public_path__ + "img/2_217.6fe67789.png";